import { Theme } from './theme'
import { Theme as MuiTheme } from '@mui/material/styles'
import _emotionStyled from '@emotion/styled'
import { useTheme as useEmotionTheme } from '@emotion/react'
import { makeStyledWithTransientProps } from './make-style-with-transient-props'

export interface Av8Theme extends MuiTheme {
  av8: Theme
}

type StyledTaggedTemplate<Av8Theme, ComponentProps = any> = <ExtensionProps = unknown>(
  strings: TemplateStringsArray,
  ...rest: Array<(props: ExtensionProps & ComponentProps & { theme: Av8Theme }) => any>
) => React.ComponentType<ExtensionProps & ComponentProps>

type StyledLikeThemed<Av8Theme = any> = {
  [TTag in keyof JSX.IntrinsicElements]: StyledTaggedTemplate<Av8Theme, JSX.IntrinsicElements[TTag]>
} &
  (<C>(
    elementType: React.Component<C> | React.FC<C> | React.JSXElementConstructor<C>
  ) => StyledTaggedTemplate<Av8Theme, C>)

export const styled = makeStyledWithTransientProps(
  _emotionStyled
) as any as StyledLikeThemed<Av8Theme>

type StyledCssTaggedTemplate<Av8Theme> = (
  strings: TemplateStringsArray,
  ...rest: Array<(props: { theme: Av8Theme }) => any>
) => (props: { theme: Av8Theme }) => string

//a first attemp to create a custom "css" to replace the styled components implementation
export const cssFactory: StyledCssTaggedTemplate<Av8Theme> = <Av8Theme>(
  strings: TemplateStringsArray,
  ...interpolations: Array<(props: { theme: Av8Theme }) => any>
) => {
  return (props: { theme: Av8Theme }) => {
    const output: string[] = []
    strings.forEach((stringValue, i) => {
      const value = interpolations[i]?.(props)
      output.push(stringValue)
      if (value !== false && value != null) output.push(value.toString())
    })
    return output.join('')
  }
}

export const useTheme = useEmotionTheme as any as () => Av8Theme
export const css: StyledCssTaggedTemplate<Av8Theme> = cssFactory
